import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { trustedIpsApi } from '../api/trustedIps';

export const TRUSTED_IPS_KEY = ['admin', 'trusted-ips'] as const;

export function useTrustedIps() {
  return useQuery({
    queryKey: TRUSTED_IPS_KEY,
    queryFn: () => trustedIpsApi.list(),
  });
}

export function useAddTrustedIp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ip, description }: { ip: string; description?: string }) =>
      trustedIpsApi.add(ip, description),
    onSuccess: () => qc.invalidateQueries({ queryKey: TRUSTED_IPS_KEY }),
  });
}

export function useRemoveTrustedIp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ip: string) => trustedIpsApi.remove(ip),
    onSuccess: () => qc.invalidateQueries({ queryKey: TRUSTED_IPS_KEY }),
  });
}
